export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY/MM/DD HH:mm',
  },
  display: {
    dateInput: 'YYYY/MM/DD HH:mm', // 2025/09/05 09:30
    monthYearLabel: 'MMM YYYY', // Sep 2025
    dateA11yLabel: 'LL', // September 5, 2025
    monthYearA11yLabel: 'MMMM YYYY', // September 2025
  },
};
